import { addCursorLoader, api, removeCursorLoader, url } from 'dmui_components'
import ReportRepository from '../repository/ReportRepository.js'

class ExpectedReportRepository {
	constructor() {
		this.reportTypes = ['fin', 'susty']
		this.fiscalMonths = Array.from({ length: 12 }, (_, i) => new Date(1, i).toLocaleString('en-US', { month: 'short' }))
		this.marketBuckets = ['Nano', 'Micro', 'Small', 'Mid', 'Large', 'Mega', 'Giga']
		this.years = [ReportRepository.getLatestYear(), ReportRepository.getLatestYear() - 1]
		this._abortController = undefined
	}

	__abortAndResetAbortController() {
		if (this._abortController) {
			this._abortController.abort()
			this._abortController = undefined
		}
		this._abortController = new AbortController()
	}

	_stringifyParams({ filters, search, page = 0, page_size = 100 }) {
		const stringFilters = {}
		for (const key in filters) {
			if (filters[key]?.length) {
				if (key === 'expected_date') {
					stringFilters[key] = filters[key]
				} else {
					stringFilters[key] = typeof filters[key][0] === 'object' ? filters[key].map((f) => f[key]) : [...filters[key]]
					if (key === 'document_type') {
						filters[key].forEach((type, index) => {
							stringFilters.document_type[index] = { document_type: type }
						})
					}
				}
			}
		}

		return JSON.stringify({
			filters: stringFilters,
			search_parameters: search || {},
			page,
			page_size
		})
	}

	async fetchReportsFromApi(modifiers = {}) {
		const stringParams = this._stringifyParams(modifiers)
		const result = { items: [], page: 0, page_size: 100 }
		try {
			this.__abortAndResetAbortController()
			addCursorLoader()
			return await api(url`/expected_report?body_string=${stringParams}`, { abortController: this._abortController })
		} catch (e) {
			console.error('Error fetching reports', e)
		} finally {
			removeCursorLoader()
		}
		return result
	}

	async fetchReportsCountFromApi(modifiers = {}) {
		const stringParams = this._stringifyParams(modifiers)
		const result = { total_count: null }
		try {
			return await api(url`/expected_report/count?body_string=${stringParams}`)
		} catch (e) {
			console.error('Error fetching reports count', e)
		}
		return result
	}

	async updateExpectedDate(reportId, expectedDate) {
		expectedDate = expectedDate?.split('.')[0]
		let urlData = url`/expected_report/${reportId}/expected_date`
		if (expectedDate) {
			urlData += `?expected_date=${expectedDate}`
		}
		try {
			addCursorLoader()
			return await api(`${urlData}`, {
				method: 'PUT'
			})
		} catch (e) {
			console.error('Error updating expected date', e)
		} finally {
			removeCursorLoader()
		}
	}

	async deleteReportAndUpdateReportMonitoring({ org_id, document_type }) {
		try {
			addCursorLoader()
			await api(`/expected_report?org_id=${org_id}&document_type=${document_type}`, {
				method: 'DELETE'
			})
		} catch (e) {
			console.error('Error updating report monitoring', e)
		} finally {
			removeCursorLoader()
		}
	}
}
export default new ExpectedReportRepository()
